"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4185],{

/***/ 80360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FieldValidationError; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95576);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);






function FieldValidationError(_param) {
    var meta = _param.meta, css = _param.css, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "meta",
        "css"
    ]);
    if (meta.touched && (meta.error || meta.submitError)) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            css: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                marginLeft: "auto",
                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__/* .red */ .Q6,
                textTransform: "uppercase",
                fontSize: 12
            }, css)
        }, props), {
            children: meta.error || meta.submitError
        }));
    }
    return null;
};


/***/ }),

/***/ 78949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "RM": function() { return /* binding */ DuplicatedLinkModal; },
  "qB": function() { return /* binding */ NewsworthyInput; },
  "ZP": function() { return /* binding */ NewsworthyField; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(56262);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+core@0.21.2_iyni55cf3gelv6eahxhjaprhn4/node_modules/@govlaunch/core/index.js + 20 modules
var core = __webpack_require__(98973);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-final-form@6.5.9_s44h3cxpdxv6cks4bnqewerqda/node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(56225);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
// EXTERNAL MODULE: ./lib/hooks/useIsMobile.ts
var useIsMobile = __webpack_require__(67459);
// EXTERNAL MODULE: ./lib/hooks/useUnfurl.ts
var useUnfurl = __webpack_require__(82757);
// EXTERNAL MODULE: ./lib/utils/isValidUrl.ts
var isValidUrl = __webpack_require__(94834);
// EXTERNAL MODULE: ./lib/utils/prefixWithHttpIfNecessary.ts
var prefixWithHttpIfNecessary = __webpack_require__(6525);
// EXTERNAL MODULE: ./components/icons/PlusIcon.tsx
var PlusIcon = __webpack_require__(49289);
// EXTERNAL MODULE: ./components/newsworthy/RelatedUrlCard.tsx
var RelatedUrlCard = __webpack_require__(90416);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(94614);
;// CONCATENATED MODULE: ./components/newsworthy/RelatedUrlCardScrollbars.tsx





function RelatedUrlCardScrollbars(_param) {
    var _visible = _param.visible, visible = _visible === void 0 ? true : _visible, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "visible",
        "children"
    ]);
    if (visible) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            css: {
                display: "flex",
                overflowX: "scroll",
                "::-webkit-scrollbar": {
                    height: 8,
                    WebkitAppearance: "none"
                },
                "::-webkit-scrollbar-thumb": {
                    borderRadius: 4,
                    backgroundColor: "rgba(165, 173, 186, 0.7)"
                },
                "::-webkit-scrollbar-track": {
                    borderRadius: 4,
                    backgroundColor: "rgba(165, 173, 186, 0.2)",
                    marginLeft: 182.5,
                    marginRight: 182.5
                }
            },
            children: children
        }));
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        css: {
            display: "flex"
        },
        children: children
    }));
}

;// CONCATENATED MODULE: ./components/form/NewsworthyField.tsx















function NewsworthyField(param) {
    var fieldName = param.fieldName, padding = param.padding;
    var intl = (0,useIntl/* default */.Z)();
    var isMobile = (0,useIsMobile/* default */.Z)();
    var ref = (0,react.useState)(false), isModalOpen = ref[0], setIsModalOpen = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
        name: fieldName,
        children: function(param) {
            var input = param.input;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DuplicatedLinkModal, {
                        isOpen: isModalOpen,
                        onClose: function() {
                            return setIsModalOpen(false);
                        },
                        text: intl.formatMessage({
                            defaultMessage: "This link has already been added, please try a different one!",
                            id: "HwqbKy"
                        }),
                        closeButtonText: "Close"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsworthyInput, {
                            onChange: function(item) {
                                if (input.value && input.value.length > 0) {
                                    var duplicatedUrl = input.value.find(function(newsworthy) {
                                        return item.url === newsworthy.url;
                                    });
                                    if (duplicatedUrl) {
                                        setIsModalOpen(true);
                                        return;
                                    }
                                    input.onChange([
                                        item
                                    ].concat(input.value));
                                } else {
                                    input.onChange([
                                        item
                                    ]);
                                }
                            },
                            padding: padding
                        })
                    }),
                    input.value && Array.isArray(input.value) && input.value.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            paddingRight: 15,
                            paddingBottom: 15,
                            paddingLeft: 15,
                            overflow: "hidden"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RelatedUrlCardScrollbars, {
                            visible: !isMobile,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: {
                                    display: "grid",
                                    flexWrap: "wrap",
                                    gridRowGap: 16,
                                    gridColumnGap: isMobile ? undefined : 16,
                                    gridTemplateColumns: isMobile ? undefined : "repeat(".concat(input.value.length, ", 320px)"),
                                    marginBottom: 10
                                },
                                children: input.value.map(function(param) {
                                    var url = param.url, title = param.title, siteName = param.siteName, description = param.description, favicon = param.favicon;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RelatedUrlCard/* RelatedUrlCard */.l, {
                                        url: url || "",
                                        title: title || "",
                                        siteName: siteName || "",
                                        description: description || "",
                                        favicon: favicon || "",
                                        onRemove: function() {
                                            input.onChange(input.value.filter(function(param) {
                                                var maybe = param.url;
                                                return url !== maybe;
                                            }));
                                        },
                                        style: {
                                            width: isMobile ? "100%" : 320
                                        }
                                    }, url || "");
                                })
                            })
                        })
                    })
                ]
            });
        }
    });
};
var NewsworthyInput = function(param) {
    var onChange = param.onChange, placeholder = param.placeholder, _padding = param.padding, padding = _padding === void 0 ? 15 : _padding;
    var ref = (0,react.useState)(""), url = ref[0], setUrl = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var inputRef = (0,react.useRef)();
    var intl = (0,useIntl/* default */.Z)();
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useUnfurl/* default */.Z)(url, function(unfurl) {
        inputRef.current.value = "";
        onChange(unfurl);
        setLoading(false);
        setUrl("");
    }, function() {}), 1), unfurling = ref2[0];
    var addItem = function() {
        var url = inputRef.current.value.trim();
        var prefixedUrl = (0,prefixWithHttpIfNecessary/* default */.Z)(url);
        if (prefixedUrl && (0,isValidUrl/* default */.Z)(prefixedUrl)) {
            setLoading(true);
            setUrl(prefixedUrl);
        } else {
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "flex",
            alignItems: "center",
            padding: padding
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    position: "relative",
                    width: "95%"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Input */.II, {
                        innerRef: inputRef,
                        onKeyDown: function(event) {
                            if (event.key !== "Enter") {
                                return;
                            }
                            event.preventDefault();
                            event.stopPropagation();
                            addItem();
                        },
                        placeholder: placeholder || intl.formatMessage({
                            defaultMessage: "Enter a URL...",
                            id: "f1FNlL"
                        }),
                        css: {
                            backgroundColor: palette/* white */.ix,
                            border: "solid 1px ".concat(palette/* lightestGray */.v2),
                            fontSize: 14,
                            height: 42,
                            paddingLeft: 20,
                            paddingRight: 20,
                            letterSpacing: 0.5,
                            color: palette/* mediumGray */.rF,
                            lineHeight: 1.14,
                            outline: "none",
                            borderRadius: 4,
                            "&:focus": {
                                border: "solid 1px ".concat(palette/* primary */.T$)
                            }
                        }
                    }),
                    (unfurling || loading) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            position: "absolute",
                            top: "50%",
                            right: 20,
                            transform: "translateY(-50%)"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* LoadingIndicator */.TF, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                css: {
                    width: "5%",
                    height: 42,
                    textAlign: "center",
                    color: palette/* sealBlue */.N9,
                    fontSize: 13,
                    cursor: "pointer",
                    marginLeft: 10,
                    border: "solid 1px ".concat(palette/* lightestGray */.v2),
                    borderRadius: 4,
                    backgroundColor: palette/* white */.ix,
                    "&:hover": {
                        backgroundColor: palette/* lightestGray */.v2
                    },
                    "&:focus": {
                        border: "solid 1px ".concat(palette/* primary */.T$)
                    },
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                },
                type: "button",
                "aria-label": intl.formatMessage({
                    defaultMessage: "Add Newsworthy item",
                    id: "+rLLjT"
                }),
                onClick: function(event) {
                    event.preventDefault();
                    addItem();
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlusIcon/* default */.Z, {})
            })
        ]
    });
};
function DuplicatedLinkModal(param) {
    var isOpen = param.isOpen, onClose = param.onClose, text = param.text, closeButtonText = param.closeButtonText;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Modal */.u_, {
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* ModalOverlay */.ZA, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* ModalContent */.hz, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* ModalHeader */.xB, {
                        px: 2
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* ModalBody */.fe, {
                        textAlign: "center",
                        children: text
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* ModalFooter */.mz, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                            variantColor: "blue",
                            mr: 2,
                            onClick: onClose,
                            children: closeButtonText
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 52105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MakersIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);




function MakersIcon(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24",
        version: "1.1"
    }, props), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("defs", {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("linearGradient", {
                    x1: "12.5656436%",
                    y1: "11.8380996%",
                    x2: "90.0806178%",
                    y2: "100%",
                    id: "linearGradient-1",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("stop", {
                            stopColor: "#55A2FA",
                            offset: "0%"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("stop", {
                            stopColor: "#B4EC51",
                            offset: "100%"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("g", {
                id: "Symbols",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("g", {
                    id: "Makers",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("g", {
                        id: "iconfinder_m-letter-uppercase-text-round-latin-keyboard_1585150",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                                d: "M12,0 C18.6190476,0 24,5.38095238 24,12 C24,18.6190476 18.6190476,24 12,24 C5.38095238,24 0,18.6190476 0,12 C0,5.38095238 5.38095238,0 12,0 Z",
                                id: "Path-2",
                                fill: "url(#linearGradient-1)"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("polygon", {
                                id: "Path",
                                fill: "#FFFFFF",
                                fillRule: "nonzero",
                                points: "15.0116959 10.3529412 12.6140351 15.2941176 11.4444444 15.2941176 9.04678363 10.3529412 9.04678363 16 7 16 7 7 9.69005848 7 11.9707602 11.9411765 14.3099415 7 17 7 17 16 15.0116959 16"
                            })
                        ]
                    })
                })
            })
        ]
    }));
};


/***/ }),

/***/ 90416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ RelatedUrlCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95576);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _components_text_Dotdotdot__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3552);
/* harmony import */ var react_progressive_image__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(78135);
/* harmony import */ var _components_spacings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52126);
/* harmony import */ var _lib_hooks_useIsPhone__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57733);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19026);











function RelatedUrlCard(_param) {
    var url = _param.url, favicon = _param.favicon, siteName = _param.siteName, title = _param.title, description = _param.description, onRemove = _param.onRemove, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "url",
        "favicon",
        "siteName",
        "title",
        "description",
        "onRemove"
    ]);
    var isPhone = (0,_lib_hooks_useIsPhone__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
        css: {
            borderRadius: 20,
            border: "solid 1px ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .lightestGray */ .v2),
            backgroundColor: "#ffffff",
            padding: "17px 20px",
            display: "flex",
            flexDirection: "column",
            position: "relative",
            height: "100%",
            minHeight: 131
        },
        children: [
            onRemove && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("button", {
                type: "button",
                onClick: function() {
                    return onRemove(url);
                },
                css: {
                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .red */ .Q6,
                    fontSize: 28,
                    outline: 0,
                    border: 0,
                    background: "none",
                    position: "absolute",
                    top: 5,
                    right: 6,
                    cursor: "pointer"
                },
                children: "\xd7"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_4__/* .Anchor */ .ee, {
                        href: url,
                        external: "outside-govlaunch",
                        css: {
                            fontSize: 16,
                            margin: 0,
                            fontWeight: 500,
                            lineHeight: 1.25,
                            paddingRight: 10,
                            textDecoration: "none",
                            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .text */ .fL,
                            display: "inline-block",
                            maxWidth: "100%"
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_text_Dotdotdot__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            clamp: isPhone ? 8 : 1,
                            children: title || siteName
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_spacings__WEBPACK_IMPORTED_MODULE_2__/* .Margin */ .Zt, {
                        mt: 5,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                            css: {
                                lineHeight: 1.29,
                                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .darkGray */ .O5,
                                fontSize: 14
                            },
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_text_Dotdotdot__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                clamp: 2,
                                children: description
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                css: {
                    marginTop: "auto"
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_components_spacings__WEBPACK_IMPORTED_MODULE_2__/* .Margin */ .Zt, {
                    mt: 10,
                    css: {
                        display: "flex",
                        alignItems: "stretch"
                    },
                    children: [
                        favicon && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_progressive_image__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            src: favicon,
                            placeholder: "",
                            children: function(src, loading) {
                                if (loading || !src) {
                                    return null;
                                }
                                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                                    css: {
                                        marginRight: 5,
                                        display: "inline-flex"
                                    },
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("img", {
                                        src: favicon.startsWith("https") ? favicon : (0,_govlaunch_web__WEBPACK_IMPORTED_MODULE_4__/* .getSecureContent */ .qc)(favicon, "outside-govlaunch"),
                                        css: {
                                            width: 16,
                                            height: 16
                                        }
                                    })
                                });
                            }
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("span", {
                            css: {
                                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_9__/* .darkGray */ .O5,
                                fontSize: 14
                            },
                            children: siteName
                        })
                    ]
                })
            })
        ]
    }));
}


/***/ }),

/***/ 3552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var react_dotdotdot__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94881);
/* harmony import */ var react_dotdotdot__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_dotdotdot__WEBPACK_IMPORTED_MODULE_1__);



var Dotdotdot = function(param) {
    var clamp = param.clamp, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(UnsafeLineClamp, {
        clamp: clamp,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)((react_dotdotdot__WEBPACK_IMPORTED_MODULE_1___default()), {
            clamp: clamp,
            children: children
        })
    });
};
function UnsafeLineClamp(param) {
    var clamp = param.clamp, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
        css: {
            lineClamp: clamp,
            WebkitLineClamp: clamp,
            WebkitBoxOrient: "vertical",
            display: "-webkit-box",
            overflow: "hidden"
        },
        children: children
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Dotdotdot);


/***/ }),

/***/ 67308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIntlValidationMessages; }
/* harmony export */ });
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69057);

function useIntlValidationMessages() {
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    return {
        cantBeBlank: intl.formatMessage({
            id: "Bom3o3",
            defaultMessage: "Can't be blank"
        }),
        invalidEmailAddress: intl.formatMessage({
            id: "5WgK3Y",
            defaultMessage: "Invalid email address"
        }),
        invalidUrl: intl.formatMessage({
            id: "SASA4f",
            defaultMessage: "Invalid URL"
        }),
        invalidYear: intl.formatMessage({
            id: "19pVnU",
            defaultMessage: "Invalid Year"
        }),
        maxCharacters: function(count) {
            return intl.formatMessage({
                id: "L28iHN",
                defaultMessage: "Maximum of {count, plural, one {# character} other {# characters}}"
            }, {
                count: count
            });
        },
        minCharacters: function(count) {
            return intl.formatMessage({
                id: "cBu7Hw",
                defaultMessage: "Minimum of {count, plural, one {# character} other {# characters}}"
            }, {
                count: count
            });
        },
        selectAMinOfXitems: function(count) {
            return intl.formatMessage({
                id: "rDx1mj",
                defaultMessage: "Please select at least {count, plural, one {# item} other {# items}}"
            }, {
                count: count
            });
        },
        selectUpToItems: function(count) {
            return intl.formatMessage({
                id: "Lsh9I0",
                defaultMessage: "Please select up to {count, plural, one {# item} other {# items}}"
            }, {
                count: count
            });
        },
        firstNameIsRequired: intl.formatMessage({
            id: "zFG+sR",
            defaultMessage: "First Name is required"
        }),
        lastNameIsRequired: intl.formatMessage({
            id: "gmqce2",
            defaultMessage: "Last Name is required"
        }),
        addressLine1: intl.formatMessage({
            id: "s1yRvp",
            defaultMessage: "Address Line 1 is required"
        }),
        city: intl.formatMessage({
            id: "W435jR",
            defaultMessage: "City is required"
        }),
        postalCode: intl.formatMessage({
            id: "eI/SH6",
            defaultMessage: "Postal Code is required"
        }),
        country: intl.formatMessage({
            id: "jlqOPq",
            defaultMessage: "Country is required"
        }),
        state: intl.formatMessage({
            id: "Lmlys/",
            defaultMessage: "State is required"
        }),
        region: intl.formatMessage({
            id: "q5Y40T",
            defaultMessage: "Region is required"
        }),
        plan: intl.formatMessage({
            id: "8c4UnH",
            defaultMessage: "Please select a plan"
        })
    };
};


/***/ }),

/***/ 57733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIsPhone; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _lib_hooks_useMediaWithInitialState__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3335);
/* harmony import */ var _components_MobileDetectContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48582);



function useIsPhone() {
    var mobileDetectContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_components_MobileDetectContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
    var isPhone =  true ? (0,_lib_hooks_useMediaWithInitialState__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("(max-width: 380px)") : 0;
    return isPhone;
};


/***/ }),

/***/ 87386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useShowMoreCounter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56262);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63402);


function useShowMoreCounter(total, limit) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,react_use__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(1), 2), count = ref[0], ref1 = ref[1], increment = ref1.inc, decrement = ref1.dec;
    var offset = Math.min(count * limit, total);
    return {
        offset: offset,
        hasMore: count * limit < total,
        hasLess: count > 1,
        showMore: function() {
            return increment(1);
        },
        showLess: function() {
            return decrement(1);
        }
    };
};


/***/ }),

/***/ 82757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useUnfurl; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18316);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _lib_utils_isValidUrl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94834);




function useUnfurl(url, onUnfurl, onError) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        loading: false,
        meta: null
    }), state = ref[0], setState = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var mounted = true;
        if ((0,_lib_utils_isValidUrl__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(url)) {
            setState({
                loading: true,
                meta: null
            });
            fetch("https://unfurl.govlaunch.com?url=".concat(encodeURIComponent(url))).then(function(response) {
                if (response.ok) {
                    return response.json().then(function(param) {
                        var govlaunch = param.govlaunch;
                        if (mounted) {
                            setState({
                                loading: false,
                                meta: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, govlaunch), {
                                    url: url
                                })
                            });
                            if (typeof onUnfurl === "function") {
                                onUnfurl((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, govlaunch), {
                                    url: url
                                }));
                            }
                        }
                    });
                } else if (mounted) {
                    setState({
                        loading: false,
                        meta: null
                    });
                    onError(new Error("Got unexpected status code: ".concat(response.status)));
                }
            }).catch(function(err) {
                if (mounted) {
                    setState({
                        loading: false,
                        meta: null
                    });
                    if (typeof onError === "function") {
                        onError(err);
                    }
                }
            });
        }
        return function() {
            mounted = false;
        };
    }, [
        url
    ]);
    return [
        state.loading,
        state.meta
    ];
};


/***/ }),

/***/ 47116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22051);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_route_ServerResponseContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14101);




var Redirect = function(param) {
    var to = param.to;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_lib_route_ServerResponseContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Consumer */ .Z.Consumer, {
        children: function(response) {
            if (response) {
                response.writeHead(303, {
                    Location: to
                });
                response.end();
                return null;
            }
            if (true) {
                next_router__WEBPACK_IMPORTED_MODULE_1___default().replace(to);
            }
            return null;
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Redirect);


/***/ }),

/***/ 94834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isValidUrl; }
/* harmony export */ });
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55423);

function isValidUrl(url) {
    return yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().url().required().isValidSync(url);
};


/***/ }),

/***/ 6525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ prefixWithHttpIfNecessary; }
/* harmony export */ });
function prefixWithHttpIfNecessary(withoutHttp) {
    if (!withoutHttp) {
        return null;
    }
    if (withoutHttp.trim().length === 0) {
        return null;
    }
    if (withoutHttp.startsWith("http")) {
        return withoutHttp;
    }
    return "http://".concat(withoutHttp);
};


/***/ })

}]);